export default __webpack_public_path__ + "static/media/calendar.4196b23b.svg";